// Firestore timestamps cross the callable boundary as plain JSON objects.
export function reviveNoteValue(value) {
  if (Array.isArray(value)) return value.map(reviveNoteValue);
  if (!value || typeof value !== 'object') return value;
  const seconds = value._seconds ?? value.seconds;
  const nanoseconds = value._nanoseconds ?? value.nanoseconds;
  if (Number.isInteger(seconds) && Number.isInteger(nanoseconds) && Object.keys(value).every(k => ['_seconds', '_nanoseconds', 'seconds', 'nanoseconds'].includes(k))) {
    const milliseconds = seconds * 1000 + nanoseconds / 1e6;
    return { seconds, nanoseconds, toDate: () => new Date(milliseconds), toMillis: () => milliseconds };
  }
  return Object.fromEntries(Object.entries(value).map(([key, child]) => [key, reviveNoteValue(child)]));
}
